export default {
  data() {
    return {
      modalConfig: null,
      showModal: false,
    }
  },

  methods: {
    afterEnterModal(el) {
      el.querySelector('.modal').scrollIntoView({behavior: 'smooth'})
    },

    closeModal() {
      this.showModal = false
      this.modalConfig = null
    },
  },
}